<script>
  import { Router, Link, Route } from "svelte-routing"
  import Home from "./pages/Home.svelte"
  import Quote from "./pages/Quote.svelte"
  import Plans from "./pages/Plans.svelte"
  import Plan from "./pages/Plan/Plan.svelte"
  import Thanks from "./pages/Thanks.svelte"
  import PlanGet from "./pages/Plan/PlanGet.svelte"
</script>

<div class="main">
  <Router>
    <nav class="p12">
      <Link to="/">Start Over</Link>
    </nav>
    <div>
      <Route path="plans" component={Plans} />
      <Route path="plans/:id" component={Plan} />
      <Route path="plans_get/:id" component={PlanGet} />
      <Route path="quote" component={Quote} />
      <Route path="thanks" component={Thanks} />
      <Route path="/" component={Home} />
    </div>
  </Router>
</div>
<footer>
  <p>
    Attention: This website is operated by <strong
      >DLS Innovation Group, Inc.</strong
    >
    and is not the Health Insurance Marketplace® website. In offering this
    website, <strong>DLS Innovation Group, Inc.</strong> is required to comply
    with all applicable Federal law, including the standards established under
    45 CFR 155.220(c) and (d) and standards established under 45 CFR 155.260 to
    protect the privacy and security of personally identifiable information.
    This website may not support enrollment in all Qualified Health Plans (QHPs)
    being offered in your state through the Health Insurance Marketplace®
    website. For enrollment support in all available QHP options in your state,
    go to the Health Insurance Marketplace® website at
    <a href="https://HealthCare.gov">HealthCare.gov</a>.
  </p>
  <p>
    Also, you should visit the Health Insurance Marketplace® website at <a
      href="https://HealthCare.gov">HealthCare.gov</a
    > if:
  </p>
  <ul>
    <li>You want to enroll members of your household in separate QHPs.</li>
  </ul>
  <p>
    <strong>DLS Innovation Group, Inc.</strong> offers the opportunity to enroll
    in either QHPs or off-Marketplace coverage. Please visit
    <a href="https://HealthCare.gov">HealthCare.gov</a> for information on the benefits
    of enrolling in a QHP. Off-Marketplace coverage is not eligible for the cost
    savings offered for coverage through the Marketplaces.
  </p>
</footer>

<style>
  .main {
    min-height: 50vh;
    min-height: 50lvh;

    text-align: center;
  }
</style>
